// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3cJlo","footer":"ModalInfo_footer__1Eo69"};